export const CIVILBUDGETSCHEDULE_LOADING = "CIVILBUDGETSCHEDULE_LOADING";
export const CIVILBUDGETSCHEDULE_RESET = "CIVILBUDGETSCHEDULE_RESET";
export const GET_CIVILBUDGETSCHEDULE = "GET_CIVILBUDGETSCHEDULE";
export const GET_CIVILBUDGETSCHEDULE_SUCCESS = "GET_CIVILBUDGETSCHEDULE_SUCCESS";
export const GET_CIVILBUDGETSCHEDULE_FAIL = "GET_CIVILBUDGETSCHEDULE_FAIL";
export const DELETE_CIVILBUDGETSCHEDULE = "DELETE_CIVILBUDGETSCHEDULE"
export const DELETE_CIVILBUDGETSCHEDULE_SUCCESS = "DELETE_CIVILBUDGETSCHEDULE_SUCCESS"
export const DELETE_CIVILBUDGETSCHEDULE_FAIL = "DELETE_CIVILBUDGETSCHEDULE_FAIL"
export const UPDATE_CIVILBUDGETSCHEDULE = "UPDATE_CIVILBUDGETSCHEDULE"
export const UPDATE_CIVILBUDGETSCHEDULE_SUCCESS = "UPDATE_CIVILBUDGETSCHEDULE_SUCCESS"
export const UPDATE_CIVILBUDGETSCHEDULE_FAIL = "UPDATE_CIVILBUDGETSCHEDULE_FAIL"
export const ADD_NEW_CIVILBUDGETSCHEDULE = "ADD_NEW_CIVILBUDGETSCHEDULE"
export const ADD_CIVILBUDGETSCHEDULE_SUCCESS = "ADD_CIVILBUDGETSCHEDULE_SUCCESS"
export const ADD_CIVILBUDGETSCHEDULE_FAIL = "ADD_CIVILBUDGETSCHEDULE_FAIL"